import { ymReachGoal } from '../../../../helpers/common';
import React, { useCallback } from 'react';
import url from 'url';
import { LogoLink } from './styled';
var Logo = function (_a) {
    var root = _a.root, logoUrl = _a.logoUrl, children = _a.children;
    var href = root
        ? '/'
        : url.format({
            protocol: 'https',
            hostname: 'pro.samoletgroup.ru',
        });
    var handleClick = useCallback(function () {
        ymReachGoal('click_logo');
    }, []);
    return (React.createElement(LogoLink, { role: 'link', href: logoUrl !== null && logoUrl !== void 0 ? logoUrl : href, onClick: handleClick }, children));
};
export { Logo };
//# sourceMappingURL=Logo.js.map